import { GlobalData } from "../Common/GlobalData";
import { Notification } from "../Common/KendoHelpers";

export class Importer {
    // Make these static so they can be accessed in the event handlers.
    private static readonly SPINNER = '#spinner';
    private static errorMessage: string;

    public constructor() {
        this.init();
    }

    private init() {
        $('#upload').kendoUpload({
            async: {
                saveUrl: GlobalData.URL_BASE +
                    GlobalData.URL_SUFFIX_IMPORT_DATA + '/save',
                removeUrl: GlobalData.URL_BASE +
                    GlobalData.URL_SUFFIX_IMPORT_DATA + '/remove',
                batch: true,
            },
            upload: this.onUpload,
            error: this.onError,
            complete: this.onComplete,
        });
    }

    private onUpload(e: kendo.ui.UploadUploadEvent) {
        $(Importer.SPINNER).show();
        Importer.errorMessage = '';
    }

    private onError(e: kendo.ui.UploadErrorEvent) {
        if (e && e.XMLHttpRequest && e.files && e.files.length) {
            const status = e.XMLHttpRequest.status;
            const fileName = e.files[0].name;

            switch (status) {
                case 400:
                    Importer.errorMessage += '<br>Exception thrown: ' + e.XMLHttpRequest.responseText;
                    break;
                case 401:
                    Importer.errorMessage = '<br>Unauthorized';
                    break;
                case 404:
                    Importer.errorMessage += '<br>Unsupported file ' + fileName;
                    break;
                default:
                    Importer.errorMessage += '<br>Error code ' + status +
                        ' returned for file ' + fileName;
            }
        }
    }

    private onComplete() {
        $(Importer.SPINNER).hide();
        const notification = new Notification(Notification.reloadPage);

        if (Importer.errorMessage.length == 0) {
            notification.success('All files imported successfully');
        } else {
            notification.error(Importer.errorMessage);
        }
    }
}

